
import { LayoutCrearDoc } from "../../layouts"
import { CargandoMedio } from "../../components";
import { useBuscadorVentasCaja } from "../../../hooks/cache";
import { BusquedaFechaTerminoMedio } from "../../components/buscadores";
import { TablaCajaVentas } from "../components";


export const CajaScreen = () => {


    const { data, isLoading, chagePage, page, termino, chageTermino, medio, chageMedioPago, 
            inicio, final, chageInicio, chageFinal, totalesVentaCaja } = useBuscadorVentasCaja();

    
    return (

        <LayoutCrearDoc titulo='Registros de Ventas' subtitulo='información en ventas' add={false}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de ventas..." />
            :   <>
                <BusquedaFechaTerminoMedio
                    termino={termino} chageTermino={chageTermino} 
                    inicio={inicio} chageInicio={chageInicio}
                    final={final} chageFinal={chageFinal} 
                    titulo='Busqueda por usuario' place='Buscar x usuario...'
                    medio={ medio } chageMedioPago={ chageMedioPago }
                />
                <TablaCajaVentas data={data || []} chagePage={chagePage} page={page} totales={totalesVentaCaja.data} />
                </>
            }
        </LayoutCrearDoc>
    )
}